import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/** Any blocked edit (read-only 403) → the friendly explainer page, remembering where the user was. */
export default function WorkspaceLockRedirect() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => {
    const onLocked = (e) => {
      e.preventDefault();
      if (pathname === "/workspace-locked") return;
      navigate("/workspace-locked", { state: { from: e.detail?.path || pathname } });
    };
    window.addEventListener("fixli:workspace-locked", onLocked);
    return () => window.removeEventListener("fixli:workspace-locked", onLocked);
  }, [navigate, pathname]);
  return null;
}
